<template>
  <div class="card technician-card">
    <div class="card-header technician-header">
      <div class="technician-title">
        <span class="technician-title__icon"><i class="ti ti-user"></i></span>
        <div>
          <strong>Technician</strong>
          <small>
            {{ employees.length }} dari {{ total || employees.length }} termuat
          </small>
        </div>
      </div>
      <span class="technician-total">
        {{ total || employees.length }}
      </span>
    </div>

    <div class="technician-search">
      <i class="ti ti-search"></i>
      <input
        v-model.trim="searchQuery"
        type="search"
        placeholder="Cari teknisi termuat..."
      />
    </div>

    <div class="card-body technician-list" @scroll.passive="handleScroll">
      <div
        v-for="item in filteredEmployees"
        :key="item.nik"
        :class="[
          'employee-item',
          {
            active: selected && selected.nik == item.nik,
          },
        ]"
        @click="select(item)"
      >
        <div class="font-weight-bold">
          {{ item.firstname }} {{ item.lastname }}
        </div>

        <small class="text-muted">
          {{ item.nik }}
        </small>
      </div>

      <div class="technician-empty" v-if="filteredEmployees.length === 0">
        <i class="ti ti-search"></i>
        <span>Teknisi tidak ditemukan pada data yang sudah termuat.</span>
      </div>

      <button
        type="button"
        class="technician-load-more"
        v-if="hasMore"
        :disabled="loading"
        @click="$emit('load-more')"
      >
        <i :class="loading ? 'ti ti-reload' : 'ti ti-angle-down'"></i>
        {{ loading ? "Memuat teknisi..." : "Muat teknisi berikutnya" }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TechnicianPanel",

  props: {
    employees: {
      type: Array,

      default: () => [],
    },

    selected: {
      type: Object,

      default: null,
    },
    total: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hasMore: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      searchQuery: "",
    };
  },

  computed: {
    filteredEmployees() {
      const keyword = this.searchQuery.toLowerCase();

      if (!keyword) return this.employees;

      return this.employees.filter((employee) => {
        const employeeName = `${employee.firstname || ""} ${
          employee.lastname || ""
        }`.toLowerCase();

        return (
          employeeName.includes(keyword) ||
          String(employee.nik || "").includes(keyword)
        );
      });
    },
  },

  methods: {
    select(item) {
      this.$emit(
        "select",

        item
      );
    },
    handleScroll(event) {
      if (this.loading || !this.hasMore) return;

      const list = event.target;
      const remainingScroll =
        list.scrollHeight - list.scrollTop - list.clientHeight;

      if (remainingScroll <= 120) {
        this.$emit("load-more");
      }
    },
  },
};
</script>

<style scoped>
.technician-card {
  border: 1px solid #e1e9ee;
  border-radius: 12px;
  box-shadow: 0 8px 22px rgba(47, 89, 111, 0.08);
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  height: 100%;
  margin-bottom: 0;
  min-height: 0;
  overflow: hidden;
}

.technician-header {
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #e8eef2;
  display: flex;
  justify-content: space-between;
  padding: 13px 14px;
}

.technician-title {
  align-items: center;
  display: flex;
  gap: 9px;
}

.technician-title__icon {
  align-items: center;
  background: #eaf6f7;
  border-radius: 8px;
  color: #318a99;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
}

.technician-title strong,
.technician-title small {
  display: block;
}

.technician-title strong {
  color: #344f60;
  font-size: 12px;
}

.technician-title small {
  color: #8a9ba6;
  font-size: 9px;
  margin-top: 2px;
}

.technician-total {
  align-items: center;
  background: #3193a7;
  border-radius: 12px;
  color: #fff;
  display: inline-flex;
  font-size: 10px;
  font-weight: 700;
  justify-content: center;
  min-width: 27px;
  padding: 4px 7px;
}

.technician-search {
  align-items: center;
  background: #f7fafc;
  border-bottom: 1px solid #e8eef2;
  display: flex;
  padding: 10px 12px;
  position: relative;
}

.technician-search i {
  color: #8a9da8;
  left: 23px;
  position: absolute;
}

.technician-search input {
  background: #fff;
  border: 1px solid #dce5ea;
  border-radius: 7px;
  color: #425b6a;
  font-size: 10px;
  min-height: 34px;
  outline: none;
  padding: 7px 10px 7px 31px;
  width: 100%;
}

.technician-search input:focus {
  border-color: #83c4cb;
  box-shadow: 0 0 0 3px rgba(49, 147, 167, 0.1);
}

.technician-list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px;
}

/* Scrollbar */
.technician-list::-webkit-scrollbar {
  width: 6px;
}

.technician-list::-webkit-scrollbar-thumb {
  background: #bfd2d8;
  border-radius: 999px;
}

.technician-list::-webkit-scrollbar-thumb:hover {
  background: #91b6bf;
}

.employee-item {
  background: #fff;
  border: 1px solid #e3eaee;
  border-radius: 9px;
  cursor: pointer;
  margin-bottom: 8px;
  padding: 11px 12px;
  transition: all 0.2s ease;
}

.employee-item:hover {
  background: #f3faf9;
  border-color: #9cd2cd;
  transform: translateY(-1px);
}

.employee-item.active {
  background: #eaf7f5;
  border-color: #3193a7;
  box-shadow: 0 4px 12px rgba(49, 147, 167, 0.12);
  color: #286f79;
}

.employee-item small {
  font-size: 9px;
}

.technician-empty {
  align-items: center;
  color: #8497a3;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  gap: 7px;
  padding: 20px 10px;
  text-align: center;
}

.technician-empty i {
  color: #76afb7;
  font-size: 20px;
}

.technician-load-more {
  background: #eef8f8;
  border: 1px dashed #91cbd0;
  border-radius: 8px;
  color: #307e89;
  cursor: pointer;
  font-size: 10px;
  font-weight: 600;
  padding: 9px;
  width: 100%;
}

.technician-load-more:hover:not(:disabled) {
  background: #e1f3f4;
}

.technician-load-more:disabled {
  cursor: wait;
  opacity: 0.7;
}

@media (max-width: 991px) {
  .technician-card {
    height: auto;
    max-height: 620px;
    min-height: 360px;
  }

  .technician-list {
    max-height: 510px;
  }
}

@media (max-width: 575px) {
  .technician-card {
    min-height: 320px;
  }

  .technician-list {
    max-height: 430px;
  }
}
</style>
